var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19,2h11.74c2.17,0,4.07,2,4.07,4.11v15.89l-4-4H6.19c-2.31,0-4.19-1.89-4.19-4.19V6.19C2,3.89,3.89,2,6.19,2Zm-2.19,11.89c0,1.16,.94,2.11,2.11,2.11h12.72l.59,.59,.58,.58V6.11c0-1.16-.94-2.11-2.11-2.11H6.11c-1.17,0-2.11,.95-2.11,2.11v7.78Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.15,12.4c-.55,0-.99,.44-.99,.99s.45,.99,.99,.99,.99-.44,.99-.99-.45-.99-.99-.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.16,
    y: 5.66,
    width: 1.99,
    height: 6.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.6e4484bdcd6e5225b1ea80a541163fcc.svg";
export { ForwardRef as ReactComponent };